<template>
  <v-container fluid class="pa-0 my-4">
      <v-card>
        <v-card-title class="grey lighten-4 py-0">
          <span class="title primary--text">Certifications</span>
          <v-spacer></v-spacer>
          <v-btn color="primary" icon flat @click.native="addCertification" v-if="certificationList.length !== 0">
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <div v-if="certificationList.length === 0" class="text-xs-center mt-2">
            <v-btn @click.native="addCertification" round color="primary">Add Certification</v-btn>
          </div>
          <v-list v-else three-line>
            <template v-for="(certificationEntity , index) in certificationList">
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-icon>card_membership</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{certificationEntity.certificationId}}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{certificationEntity.certificationName}} &nbsp; From: {{certificationEntity.authorityName}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn color="primary" flat icon @click.native="editCertification(certificationEntity)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="index + 1 !== certificationList.length"></v-divider>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    <v-dialog v-model="dialog.open" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="dialog.open = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-menu v-model="deleteDialogOpen"
              :close-on-content-click="false" v-show="certification.id !== null">
              <v-btn flat dark  slot="activator">Delete</v-btn>
              <v-card>
                <v-card-title>
                  <span class="headline error--text">Delete Data</span>
                </v-card-title>
                <v-card-text>
                  Sure you want to delete this record?
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="error" outline round @click.native="deleteDialogOpen = false">No</v-btn>
                  <v-btn color="error" round @click.native="deleteCertification" :loading="loading" :disabled="loading">Yes</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-btn dark flat @click.native="saveCertification" :loading="loading" :disabled="loading">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="certificationForm">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field name="certificationName" label="Certification Name" value="Input text" v-model="certification.certificationName" :rules="rules.certificationName" :counter="64" box required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field name="authorityName" label="Authority Name" v-model="certification.authorityName" :rules="rules.authorityName" :counter="64" box required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field name="certificationId" label="Certification Id (optional)"  v-model="certification.certificationId" :rules="rules.certificationId" :counter="64" box></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
/* globals Store */
import { mapState } from 'vuex'
export default {
  name: 'CertificationCard',
  data () {
    return {
      rules: {
        isRequired: [
          (v) => !!v || 'Required'
        ],
        certificationId: [
          (v) => (!v || v.length <= 64) || 'Certification Id must be less than 32 characters'
        ],
        certificationName: [
          (v) => !!v || 'Certification Name is required',
          (v) => (v && v.length <= 64) || 'Certification Name must be less than 32 characters'
        ],
        authorityName: [
          (v) => !!v || 'Authority Name is required',
          (v) => (v && v.length <= 64) || 'Authority Name must be less than 32 characters'
        ]
      },
      dialog: {
        open: false
      },
      deleteDialogOpen: false
    }
  },
  created () {
    Store.dispatch('profile/getCertificationList')
  },
  computed: {
    ...mapState('profile', {
      certification: 'certification',
      certificationList: 'certificationList',
      loading: 'loading'
    }),
    title () {
      if (this.certification.id === null) return 'Add Certification'
      else return 'Edit Certification'
    }
  },
  methods: {
    cb () {
      this.$refs.certificationForm.reset()
      this.dialog.open = false
    },
    editCertification (certification) {
      Store.dispatch('profile/updateCertificationForm', { ...certification })
      this.dialog.open = true
    },
    addCertification () {
      Store.dispatch('profile/updateCertificationForm', null)
      // this.cb()
      this.$refs.certificationForm.reset()
      this.deleteDialogOpen = false
      this.dialog.open = true
    },
    async deleteCertification () {
      await Store.dispatch('profile/deleteCertification', {id: this.certification.id, cb: this.cb})
    },
    async saveCertification () {
      if (this.$refs.certificationForm.validate()) {
        const certification = { ...this.certification }
        await Store.dispatch('profile/saveCertification', { certification, cb: this.cb })
        // this.cb()
        // this.dialog.open = false
      }
    },
    cancelForm () {
      Store.dispatch('profile/updateCertificationForm', null).then(this.cb)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CertificationCard.vue